var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_280_1680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2769 22.5764C5.17897 21.752 1.28613 17.3305 1.28613 11.9999C1.28613 6.08259 6.08308 1.28564 12.0004 1.28564C17.3286 1.28564 21.7484 5.17488 22.5757 10.2693M15.429 22.154C16.2448 21.8785 17.0166 21.5077 17.7311 21.0544M22.1541 15.4285C21.8774 16.2483 21.5042 17.0236 21.0481 17.7411",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_1680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgSpinner as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yODBfMTY4MCkiPgogICAgICAgIDxwYXRoIGQ9Ik0xMC4yNzY5IDIyLjU3NjRDNS4xNzg5NyAyMS43NTIgMS4yODYxMyAxNy4zMzA1IDEuMjg2MTMgMTEuOTk5OUMxLjI4NjEzIDYuMDgyNTkgNi4wODMwOCAxLjI4NTY0IDEyLjAwMDQgMS4yODU2NEMxNy4zMjg2IDEuMjg1NjQgMjEuNzQ4NCA1LjE3NDg4IDIyLjU3NTcgMTAuMjY5M00xNS40MjkgMjIuMTU0QzE2LjI0NDggMjEuODc4NSAxNy4wMTY2IDIxLjUwNzcgMTcuNzMxMSAyMS4wNTQ0TTIyLjE1NDEgMTUuNDI4NUMyMS44Nzc0IDE2LjI0ODMgMjEuNTA0MiAxNy4wMjM2IDIxLjA0ODEgMTcuNzQxMSIKICAgICAgICAgICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjcxNDI5IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzI4MF8xNjgwIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICA8L2RlZnM+Cjwvc3ZnPgo=";